Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = promotedResultsReducer;

var _constants = require('../constants');

function promotedResultsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  if (action.type === _constants.SET_PROMOTED_RESULTS) {
    var results = action.results.map(function (item) {
      return _extends({}, item, {
        _promoted: true
      });
    });
    return results;
  }

  return state;
}